import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import arrow from '../../assets/images/select-arrow.svg';

import './styles.css';

const FilterItemType = ({ onChange, options, itemTypeSelected }) => (
  <div styleName="filterGroup">
    <div styleName="filterLabel">Filter</div>
    <div styleName="filter">
      <select
        id="filterSelect"
        styleName="filterSelect"
        value={itemTypeSelected}
        onChange={onChange}
      >
        {options.map(opt => (
          <option
            className="optItem"
            styleName="filterItem"
            key={`opt${uniqueId()}`}
          >{opt}
          </option>))}
      </select>
      <input
        type="image"
        styleName="filterArrow"
        src={arrow}
        alt="arrow"
      />
    </div>
  </div>
);

FilterItemType.propTypes = {
  onChange: PropTypes.func,
  itemTypeSelected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
};

FilterItemType.defaultProps = {
  onChange: () => {},
  itemTypeSelected: '',
  options: [''],
};

export default FilterItemType;



// WEBPACK FOOTER //
// ./src/components/BaseFilteredList/FilterItemType.js